<template>
  <div
    class="cart-pill"
    :class="{ 'is-shaking': shaking, 'cart-pill--on-cart': $route.path === '/cart' }"
    role="button"
    tabindex="0"
    @click="goToCart"
    @keyup.enter="goToCart"
    title="কার্ট দেখুন"
  >
    <div class="cart-pill__top">
      <i class="fa fa-shopping-bag cart-pill__icon"></i>
      <span class="cart-pill__count">{{ count }} Items</span>
    </div>
    <div class="cart-pill__bottom">
      <span class="cart-pill__price">৳{{ total }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "CartPill",
  data() {
    return {
      count: 0,
      total: "0.00",
      shaking: false,
    };
  },
  mounted() {
    this.refresh();
    // Global, store-less signal fired by every add/remove/qty change.
    this._onCartUpdated = this.onCartUpdated.bind(this);
    window.addEventListener("cart-updated", this._onCartUpdated);
  },
  beforeDestroy() {
    window.removeEventListener("cart-updated", this._onCartUpdated);
  },
  methods: {
    onCartUpdated() {
      this.refresh();
      this.shake();
    },
    refresh() {
      const sessionId = localStorage.getItem("session_id");
      if (!sessionId) {
        this.count = 0;
        this.total = "0.00";
        return;
      }
      // Read-only; never touches the order payload keys.
      this.$http
        .get("cart/" + sessionId)
        .then((response) => {
          const data = response && response.data ? response.data : {};
          this.count = parseInt(data.count || 0);
          this.total = parseFloat(data.total || 0).toFixed(2);
          // Keep the header badge helpers in sync.
          try {
            localStorage.setItem("cartCount", this.count);
            localStorage.setItem("cartAmount", this.total);
          } catch (e) {
            /* ignore storage failures */
          }
        })
        .catch(() => {
          /* leave last known values; never block the UI */
        });
    },
    shake() {
      this.shaking = false;
      // next tick so the class re-applies even on rapid consecutive adds
      this.$nextTick(() => {
        this.shaking = true;
        setTimeout(() => {
          this.shaking = false;
        }, 700);
      });
    },
    goToCart() {
      if (this.$route && this.$route.path === "/cart") return;
      this.$router.push("/cart");
    },
  },
};
</script>

<style scoped>
.cart-pill {
  position: fixed;
  right: 8px;
  top: 50%;
  transform: translateY(-50%);
  z-index: 1050;
  width: 66px;
  display: flex;
  flex-direction: column;
  text-align: center;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 5px 16px rgba(170, 66, 66, 0.32);
  cursor: pointer;
  user-select: none;
  transition: box-shadow 0.18s, transform 0.18s;
}
.cart-pill:hover {
  box-shadow: 0 7px 22px rgba(170, 66, 66, 0.42);
}

/* Top segment — primary background */
.cart-pill__top {
  background: #aa4242;
  color: #fff;
  padding: 7px 6px 6px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 3px;
}
.cart-pill__icon {
  font-size: 16px;
}
.cart-pill__count {
  font-size: 10.5px;
  font-weight: 600;
}

/* Bottom segment — white background */
.cart-pill__bottom {
  background: #fff;
  color: #aa4242;
  padding: 6px;
  border-top: 1px solid rgba(170, 66, 66, 0.15);
}
.cart-pill__price {
  font-size: 12.5px;
  font-weight: 700;
}

/* Shake on add */
.cart-pill.is-shaking {
  animation: cartPillShake 0.7s cubic-bezier(0.36, 0.07, 0.19, 0.97) both;
}
@keyframes cartPillShake {
  10%, 90% { transform: translateY(-50%) translateX(-1px) rotate(-2deg); }
  20%, 80% { transform: translateY(-50%) translateX(2px) rotate(2deg); }
  30%, 50%, 70% { transform: translateY(-50%) translateX(-4px) rotate(-4deg); }
  40%, 60% { transform: translateY(-50%) translateX(4px) rotate(4deg); }
}

@media (max-width: 767px) {
  /* Hide the pill on the cart page in mobile view (kept on desktop) */
  .cart-pill--on-cart {
    display: none;
  }
  .cart-pill {
    width: 58px;
    right: 6px;
  }
  .cart-pill__top { padding: 6px 5px 5px; }
  .cart-pill__icon { font-size: 15px; }
  .cart-pill__count { font-size: 10px; }
  .cart-pill__bottom { padding: 5px; }
  .cart-pill__price { font-size: 11.5px; }
}
</style>
